import { render, staticRenderFns } from "./HomeUpdateWidgets.vue?vue&type=template&id=4316d57a&"
import script from "./HomeUpdateWidgets.vue?vue&type=script&lang=js&"
export * from "./HomeUpdateWidgets.vue?vue&type=script&lang=js&"
import style0 from "./HomeUpdateWidgets.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports